import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
 url: "https://auth.adptifyx.com",   // <-- production Keycloak URL
  realm: "HMS",
  clientId: "hmsui"
});

export default keycloak;